import { combineReducers } from 'redux'
import authReducer from './authReducer'
import sidePanelReducer from './sidePanelReducer' 

const appReducer = combineReducers({
    auth: authReducer,
    sidePanel: sidePanelReducer
})

export default appReducer